<template>
  <div class="room dehumidifier-small" v-loading="loadingData">
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagLeft">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineLeftOpts" :series="humidityLineLeftData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarLeftOpts" :series="humidityBarLeftData"></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block" :class="warningFlagRight">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineRightOpts" :series="humidityLineRightData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarRightOpts" :series="humidityBarRightData"></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="air-wrap" :class="warningFlagAir">
          <div class="air-title">{{ airTitle }}</div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData1"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData2"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData3"></single-histogram>
            </div>
          </div>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleL1" :series="switchDataL1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleL2" :series="switchDataL2"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleL3" :series="switchDataL3"></SwitchStatus>
          <RunningTimeBig class="device-block-time-left" :title="runningTimeTitleL" :series="runningTimeDataL"></RunningTimeBig>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleR1" :series="switchDataR1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleR2" :series="switchDataR2"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleR3" :series="switchDataR3"></SwitchStatus>
          <div class="device-block-time-right-container">
            <RunningTimeBig class="device-block-time-right" :title="runningTimeTitleR1" :series="runningTimeDataR1"></RunningTimeBig>
            <RunningTimeBig class="device-block-time-right" :title="runningTimeTitleR2" :series="runningTimeDataR2"></RunningTimeBig>
          </div>
        </div>
      </div>

      <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
  </div>
</template>

<script>
import configJson from "./config/ventilation.json";

export default {
  name: "ventilation",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      deviceNameLeft: "",
      deviceNameRight: "",
      deviceNameVentilation: "",
      warningFlagLeft: "",
      warningFlagRight: "",
      warningFlagAir: "",
      deviceList: [],
      stationName: "",
      humidityLineLeftData: null,
      humidityBarLeftData: null,
      humidityLineRightData: null,
      humidityBarRightData: null,
      singleHisData1: {},
      singleHisData2: {},
      singleHisData3: {},
      switchDataL1: null,
      switchDataL2: null,
      switchDataL3: null,
      switchDataR1: null,
      switchDataR2: null,
      switchDataR3: null,
      runningTimeDataL: null,
      runningTimeDataR1: null,
      runningTimeDataR2: null,

      singleHisOpts1: { title: "氧气", histogramName1: "%", max: 22 },
      singleHisOpts2: {
        title: "一氧化碳",
        histogramName1: "ppm",
        max: 600,
      },
      singleHisOpts3: {
        title: "VOC",
        histogramName1: "ppm",
        max: 600,
      },
    };
  },
  computed: {
    humidityLineLeftOpts: function () {
      return {
        title: this.stationName + "新风温湿度",
        legend1: "新风湿度",
        legend2: "新风温度",
      };
    },
    humidityBarLeftOpts: function () {
      return {
        title: "新风温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineRightOpts: function () {
      return {
        title: this.stationName + "新风混合温湿度",
        legend1: "新风混合湿度",
        legend2: "新风混合温度",
      };
    },
    humidityBarRightOpts: function () {
      return {
        title: "新风混合温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    airTitle: function () {
      return this.stationName + "排风";
    },
    switchTitleL1: function () {
      return "新风" + this.deviceNameLeft + "运行";
    },
    switchTitleL2: function () {
      return "新风" + this.deviceNameRight + "运行";
    },
    switchTitleL3: function () {
      return "排风" + this.deviceNameVentilation + "运行";
    },
    runningTimeTitleL: function () {
      return "排风" + this.deviceNameVentilation + "运行时间";
    },

    switchTitleR1: function () {
      return "新风" + this.deviceNameLeft + "故障";
    },
    switchTitleR2: function () {
      return "新风" + this.deviceNameRight + "故障";
    },
    switchTitleR3: function () {
      return "排风" + this.deviceNameVentilation + "故障";
    },
    runningTimeTitleR1: function () {
      return "新风" + this.deviceNameLeft + "运行时间";
    },

    runningTimeTitleR2: function () {
      return "新风" + this.deviceNameRight + "运行时间";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlagAir = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.deviceNameLeft = configJson[routerName].deviceNameLeft;
      this.deviceNameRight = configJson[routerName].deviceNameRight;
      this.deviceNameVentilation = configJson[routerName].deviceNameVentilation;
      console.log(this.deviceNameLeft);
      console.log(this.deviceNameRight);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        this.setAirWrapData(
          currentData,
          this.deviceIdList,
          "排风氧气含量",
          "排风CO含量",
          "排风VOC含量",
          "singleHisData1",
          "singleHisData2",
          "singleHisData3",
          "warningFlagAir"
        );

        this.setPieHistogramDataAndError(currentData, "humidityBarLeftData", "新风温度", "新风湿度", "warningFlagLeft");
        this.setPieHistogramDataAndError(currentData, "humidityBarRightData", "新风混合温度", "新风混合湿度", "warningFlagRight");

        const switchIdL1 = this.findDeviceId(this.switchTitleL1);
        const switchIdL2 = this.findDeviceId(this.switchTitleL2);
        const switchIdL3 = this.findDeviceId(this.switchTitleL3);
        const switchIdR1 = this.findDeviceId(this.switchTitleR1);
        const switchIdR2 = this.findDeviceId(this.switchTitleR2);
        const switchIdR3 = this.findDeviceId(this.switchTitleR3);
        this.switchDataL1 = {
          data: currentData[switchIdL1].value,
          isError: currentData[switchIdL1].errorLevel,
        };
        this.switchDataL2 = {
          data: currentData[switchIdL2].value,
          isError: currentData[switchIdL2].errorLevel,
        };
        this.switchDataL3 = {
          data: currentData[switchIdL3].value,
          isError: currentData[switchIdL3].errorLevel,
        };

        this.switchDataR1 = {
          data: currentData[switchIdR1].value,
          isError: currentData[switchIdR1].errorLevel,
          isZh: true,
        };
        this.switchDataR2 = {
          data: currentData[switchIdR2].value,
          isError: currentData[switchIdR2].errorLevel,
          isZh: true,
        };
        this.switchDataR3 = {
          data: currentData[switchIdR3].value,
          isError: currentData[switchIdR3].errorLevel,
          isZh: true,
        };

        const runningTimeIdL = this.findDeviceId(this.runningTimeTitleL);
        this.runningTimeDataL = currentData[runningTimeIdL].value;
        const runningTimeIdR1 = this.findDeviceId(this.runningTimeTitleR1);
        this.runningTimeDataR1 = currentData[runningTimeIdR1].value;
        const runningTimeIdR2 = this.findDeviceId(this.runningTimeTitleR2);
        this.runningTimeDataR2 = currentData[runningTimeIdR2].value;
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceNameL = "新风温度";
      let humidityDeviceNameL = "新风湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameL)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameL))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineLeftData", "warningFlagLeft");
          })
        );

      let temperatureDeviceNameR = "新风混合温度";
      let humidityDeviceNameR = "新风混合湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameR)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameR))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineRightData", "warningFlagRight");
          })
        );
    },
    setAirWrapData(
      currentData,
      deviceIdList,
      singleHisDeviceName1,
      singleHisDeviceName2,
      singleHisDeviceName3,
      singleHisDataName1,
      singleHisDataName2,
      singleHisDataName3,
      errorName
    ) {
      const singleHisDeviceId1 = this.findDeviceId(singleHisDeviceName1, deviceIdList);
      const singleHisDeviceId2 = this.findDeviceId(singleHisDeviceName2, deviceIdList);
      const singleHisDeviceId3 = this.findDeviceId(singleHisDeviceName3, deviceIdList);

      this[singleHisDataName1] = {
        data: currentData[singleHisDeviceId1].value,
      };
      this[singleHisDataName2] = {
        data: currentData[singleHisDeviceId2].value,
      };
      this[singleHisDataName3] = {
        data: currentData[singleHisDeviceId3].value,
      };

      this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], currentData[singleHisDeviceId1].errorLevel);
      this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], currentData[singleHisDeviceId2].errorLevel);
      this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], currentData[singleHisDeviceId3].errorLevel);
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-small {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;

      .device-block-line-item-top-left {
        display: flex;
        justify-content: space-between;
        height: 140px;
        width: 100%;
      }

      .device-block-line-item-top-right {
        display: flex;
        justify-content: space-between;
        height: 89px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        flex-shrink: 0;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .device-block-time-left {
        height: calc(100% - 145px);
        width: 100%;
        box-sizing: border-box;
      }
      .device-block-time-right-container {
        height: calc(100% - 145px);
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .device-block-time-right {
        height: calc(50% - 5px);
        width: 100%;
        box-sizing: border-box;
      }

      .air-wrap {
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        padding: 0 10px;
        // width: calc(50% - 10px);
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.6);
        box-sizing: border-box;

        .air-title {
          padding: 20px 15px 10px 10px;
          font-size: 22px;
          color: #515151;
        }

        .air-chart-wrap {
          display: flex;
          flex: 1;
        }

        .air-chart {
          padding: 20px 0;
          box-sizing: border-box;
          width: 33.3333%;
        }
      }
    }
  }
}
</style>
